import React, { useEffect, useState } from 'react'
import { Table, Button } from 'antd'
import { RightCircleOutlined } from '@ant-design/icons'
import { JobStatus, FileLink } from '../../components'
import { useRouter } from '../../../../routes'
import { useData } from '../../../../data'
import { trackPromise, usePromiseTracker } from 'react-promise-tracker'


/** 
 * Job Logs table
 */
const JobLogs = ({ tool_id }) => {
    const [jobs, setJobs] = useState([])
    const [count, setCount] = useState(0)
    const [pageSize, setPageSize] = useState(10)
    const [currentPage, setCurrentPage] = useState(1)

    const router = useRouter()
    const data = useData()
    const tools = data.tools()

    // open the details 
    const showDetails = (record) => {
        const { id } = record

        router.push(`/dashboard/job?id=${id}`)
    }

    useEffect(() => {
        trackPromise(
            tools.getToolJobs(tool_id, pageSize, currentPage)
                .then(response => {
                    const { jobs, count } = response
                    setJobs(jobs)
                    setCount(count)
                }).catch(err => {
                    console.log(err)
                })
        )
    }, [pageSize, currentPage])

    /**
     * Job logs table schema
     */
    const jobLogs = [
        {
            key: 'id',
            dataIndex: 'id',
            title: 'Id',
            sorter: (a, b) => a.id - b.id,

        },
        {
            key: 'name',
            dataIndex: 'name',
            title: 'Name',
            sorter: (a, b) => a.name.length - b.name.length,
            sortDirections: ['descend', 'ascend'],
        },
        {
            key: 'user',
            title: 'User',
            dataIndex: 'created_by_name'
        },

        {
            key: 'status',
            dataIndex: 'status',
            title: 'Status',
            render: (text, _) => <JobStatus status={text} />,
            sorter: (a, b) => a.status.length - b.status.length,
            sortDirections: ['descend', 'ascend'],
        },
        {
            key: 'input',
            dataIndex: 'input_file',
            title: 'Input',
            render: (text, _) => text ? <FileLink file_url={text} /> : <p>-</p>
        },
        {
            key: 'actions',
            render: (_, record) => <Button type="link" icon={<RightCircleOutlined />} onClick={() => showDetails(record)} href={"job?id=" + record.id}></Button>
        }

    ]

    const { promiseInProgress } = usePromiseTracker()

    const changePage = page => {
        setCurrentPage(page)
    }

    const changeSize = (currentPage, size) => {
        setCurrentPage(currentPage)
        setPageSize(size)
    }

    return (
        <Table
            dataSource={jobs}
            columns={jobLogs}
            pagination={{ pageSize, showSizeChanger: true, total: count, current: currentPage, onChange: changePage, onShowSizeChange: changeSize }}
            loading={promiseInProgress}
        />
    )
}



export default JobLogs
